// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"254":"1fdb7ee6","711":"3fb0f9ff","835":"1fdb7ee6"}[chunkId] + ".chunk.css";
};